import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'comment';

const commentService = {
  getItems: (subMenuUrl, lineId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(subMenuUrl)}/${encodeURIComponent(lineId)}`,
    });
  },

  getItemCount: (subMenuUrl, lineId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/count/${encodeURIComponent(subMenuUrl)}/${encodeURIComponent(lineId)}`,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default commentService;
